export default "__VITE_ASSET__ade3d575__"